import { render } from "./CateringUpload.vue?vue&type=template&id=536d622a&scoped=true"
import script from "./CateringUpload.vue?vue&type=script&lang=js"
export * from "./CateringUpload.vue?vue&type=script&lang=js"

import "./CateringUpload.vue?vue&type=style&index=0&id=536d622a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-536d622a"]])

export default __exports__